import { fromPromise } from 'xstate';
import { apolloClient } from '@/lib/apollo';
import { BrowseSchedulesQuery, PublishScheduleMutation } from '@/lib/gql/__generated__/canonical-documents';
import type {
  PublishScheduleInput,
  BrowseSchedulesQueryQuery,
  PublishScheduleMutationMutation,
} from '@/lib/gql/__generated__/graphql';

export type PublishScheduleResult = { response: PublishScheduleMutationMutation; scheduleId: string };

export const browseSchedulesActor = fromPromise<BrowseSchedulesQueryQuery, undefined>(async () => {
  const result = await apolloClient.query({ query: BrowseSchedulesQuery });
  if (!result.data) throw new Error('The schedule cache returned no data.');
  return result.data;
});

export const publishScheduleActor = fromPromise<
  PublishScheduleResult,
  Pick<PublishScheduleInput, 'routes' | 'directions' | 'stops' | 'scheduledArrivals'>
>(async ({ input }) => {
  const scheduleId = crypto.randomUUID();
  const result = await apolloClient.mutate({
    mutation: PublishScheduleMutation,
    variables: {
      input: {
        scheduleId,
        routes: input.routes,
        directions: input.directions,
        stops: input.stops,
        scheduledArrivals: input.scheduledArrivals,
      },
    },
  });
  if (!result.data) throw new Error('The schedule publish request returned no data.');
  return { response: result.data, scheduleId };
});
